/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import { DeliveryOptionsCartLineAddress } from '@msdyn365-commerce-modules/retail-actions';
import { ITelemetryContent } from '@msdyn365-commerce-modules/utilities';
import { CartLine } from '@msdyn365-commerce/retail-proxy';
import React, { useState, useEffect } from 'react';

export interface ICheckoutCartLineCompleteShipmentProps {
    className?: string;
    isDisabled?: boolean;
    minRangeValue?: string;
    maxRangeValue?: string;
    validationErrorForRange?: string;
    fallbackPattern?: string;
    ariaLabel?: string;
    telemetryContent?: ITelemetryContent;
    disclaimerText?: string;
    deliveryMethodCostInfoBanner?: string;
    heading?: string;
    checkBoxLabel?: string;
    onChangeMinValue?: void;
    id?: string;
    cartLines?: CartLine[];
    groupDeliveryOption?: DeliveryOptionsCartLineAddress;
    onChange(event: React.ChangeEvent<HTMLInputElement>, cartLines: CartLine[]): void;
}

const STORAGE_KEY = 'isCompleteShipment';

const CheckoutCartLineCompleteShipment: React.FC<ICheckoutCartLineCompleteShipmentProps> = ({
    className,
    ariaLabel,
    checkBoxLabel,
    disclaimerText,
    deliveryMethodCostInfoBanner,
    onChange,
    cartLines,
    groupDeliveryOption
}) => {
    const [isCompleteShipment, setIsCompleteShipment] = useState<boolean>(() => {
        const storedValue = localStorage.getItem(STORAGE_KEY);
        return storedValue === 'true';
    });

    useEffect(() => {
        localStorage.setItem(STORAGE_KEY, isCompleteShipment.toString());
    }, [isCompleteShipment]);

    const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const isChecked = event.target.checked;

        if (isChecked !== isCompleteShipment) {
            setIsCompleteShipment(isChecked);

            if (groupDeliveryOption !== undefined && cartLines !== undefined) {
                const cartLinesChecked: CartLine[] = [];
                groupDeliveryOption?.cartLineIds?.forEach(cartLineId => {
                    const tempCartLine = cartLines?.find(cartLine => cartLineId === cartLine?.LineId?.toString());
                    if (tempCartLine !== undefined) {
                        cartLinesChecked.push(tempCartLine);
                    }
                });

                if (cartLinesChecked.length > 0) {
                    onChange(event, cartLinesChecked);
                }
            }
        }
    };

    return (
        <div className={className}>
            <span className={`${className}__disclaimer`}>{disclaimerText}</span>
            <div>
                <input
                    className={`${className}__checkbox`}
                    type='checkbox'
                    aria-label={ariaLabel}
                    name='requestDeliveryDate'
                    checked={isCompleteShipment}
                    onChange={handleCheckboxChange}
                />
                <span className={`${className}__lbl`}>{checkBoxLabel}</span>
            </div>
        </div>
    );
    // <span className={`${className}__disclaimer`}>{deliveryMethodCostInfoBanner}</span>
};

export default CheckoutCartLineCompleteShipment;
